<script setup lang="ts">
import { getAuthorDisplayName } from '@@/bits/author'
import device from '@@/bits/device'
import { __ } from '@@/bits/intl'
import { blankUser, isRegistered as isUserRegistered } from '@@/bits/user_model'
import { type User } from '@@/types'
import AvatarImage from '@@/vuecomponents/avatar_image.vue'
import emitClickOnTouch from '@@/vuedirectives/emit_click_on_touch'
import { computed } from 'vue'

const vEmitClickOnTouch = emitClickOnTouch

const props = defineProps<{
  author: User | null
  avatarSize: 14 | 24
  darkMode: boolean
}>()

const authorName = computed<string>(() => {
  return getAuthorDisplayName(props.author ?? blankUser())
})

const authorProfileUrl = computed<string>(() => {
  return props.author?.profile_url || ''
})

const isRegistered = computed<boolean>(() => {
  return props.author ? isUserRegistered(props.author) : false
})
</script>

<template>
  <div :class="['flex', 'items-center', 'overflow-hidden']">
    <component
      :is="isRegistered ? 'a' : 'span'"
      v-emit-click-on-touch
      :class="['flex items-center min-w-0', isRegistered ? 'cursor-pointer' : 'cursor-default']"
      :href="authorProfileUrl"
      target="_blank"
      data-bridged-link="profile"
      :data-bridged-link-username="author ? author.username : undefined"
      :aria-label="isRegistered ? __('Go to %{profileName} profile', { profileName: authorName }) : undefined"
      :title="isRegistered ? __('Go to %{profileName} profile', { profileName: authorName }) : undefined"
      @click="(event) => !device.app && event.stopPropagation()"
    >
      <AvatarImage :user="author && isRegistered ? author : {}" :width="avatarSize" :height="avatarSize" />
      <span
        :class="[
          avatarSize === 14 ? 'text-body-extra-small' : 'text-body',
          'ms-1',
          {
            'text-light-text-200': darkMode === true,
            'text-dark-text-200': darkMode === false,
          },
          'truncate',
        ]"
        >{{ authorName }}
      </span>
    </component>
  </div>
</template>
